// components/RichTextEditor.jsx
import React, {
  forwardRef,
  useEffect,
  useRef,
  useImperativeHandle,
} from "react";

export default forwardRef(function RichTextEditor(
  { html, onInput, onKeyDown, style, placeholder },
  ref
) {
  const elRef = useRef(null);

  // expone el DOM real al padre (editorRef)
  useImperativeHandle(ref, () => elRef.current);

  // solo actualiza el contenido cuando el prop 'html' CAMBIE desde fuera
  useEffect(() => {
    if (!elRef.current) return;
    const next = html || "";
    if (elRef.current.innerHTML !== next) {
      elRef.current.innerHTML = next;
    }
  }, [html]);

  return (
    <div
      ref={elRef}
      contentEditable
      suppressContentEditableWarning
      data-placeholder={placeholder}
      onKeyDown={onKeyDown}
      onInput={onInput}
      style={{
        minHeight: 100,
        padding: 12,
        background: "#FFF",
        outline: "none",
        fontSize: 14,
        color: "#333",
        overflowY: "auto",
        ...style,
      }}
    />
  );
});
